import {ActivityModel} from '../../models';

export default {
    namespaced: true,
    state: {
        questIsSaving: false,
    },
    mutations: {
        setQuestIsSaving(state, val) {
            state.questIsSaving = val;
        },
    },
    actions: {
        saveQuest({commit}, {quest, body}) {
            commit('setQuestIsSaving', true);

            return ActivityModel
                .patch(quest.id, {
                    params: {
                        'response-group': 'org_backend_quest_details',
                    },
                    body,
                })
                .then((result) => {
                    Object.keys(body).forEach(field => quest[field] = result[field]);

                    return result;
                })
                .finally(() => {
                    commit('setQuestIsSaving', false);
                });
        },
    },
};